<template>
  <div>
    <the-nav-bar class="nav-header">
      <div class="nav-title row-center">
        <img class="nav-title-icon" :src="ad.asset.iconUrl" alt="" />
        <span
          >{{ getSideTrans(ad.type).side }} {{ ad.asset.symbol }}
          {{ ad.asset.name }}</span
        >
      </div>
      <div class="nav-right row-center" slot="right">
        <span v-if="ad.location.name && navLangMain">{{
          $root.countries.getName(ad.location.name, navLangMain)
        }}</span>
        <span
          v-if="ad.location.name"
          class="flag-icon flag-icon-squared"
          :class="`flag-icon-${ad.location.name.toLowerCase()}`"
        ></span>
      </div>
    </the-nav-bar>
    <div class="body-wrapper">
      <div class="merchant-panel">
        <div class="merchant-header row-align-center">
          <svg class="icon">
            <use
              :xlink:href="ad.type == 'sell' ? '#icon-cart' : '#icon-shop'"
            />
          </svg>
          <span>{{ title }}</span>
        </div>
        <div class="merchant-body row-justify">
          <div class="merchant-col-left">
            <div class="merchant-left-header">
              <img
                :src="ad.user.avatarUrl || defaultAvatarUrl"
                class="avatar"
              />
              <span class="name strong">{{ ad.user.nickname }}</span>
            </div>
            <div class="merchant-left-body col">
              <span class="exchange-count">
                ~
                {{
                  $t('exchange.tradeCount', {
                    count: ad.user.multisigOrderCount,
                  })
                }}
              </span>
              <span>
                ~ {{ ad.user.in5minRate | formatRate }}
                {{ $t('exchange.fast') }}
              </span>
              <span>
                ~ {{ ad.user.orderSuccessRank | formatRate }}
                {{ $t('exchange.successRate') }}
              </span>
              <span>
                ~ {{ ad.user.rateRank | formatRate }}
                {{ $t('exchange.praise') }}
              </span>
              <span class="tag row-align-center" v-if="ad.user.hasCertified">
                <svg class="icon">
                  <use xlink:href="#icon-certified-colorful" />
                </svg>
                <span>{{ $t('exchange.blueTrust') }}</span>
              </span>
              <span class="tag tag-video row-align-center" v-if="ad.user.hasVideo">
                <svg class="icon">
                  <use xlink:href="#icon-video2" color="black" />
                </svg>
                <span>{{ $t('exchange.kycVideo') }}</span>
              </span>
              <span class="tag row-align-center" v-if="ad.user.hasVerified">
                <svg class="icon">
                  <use xlink:href="#icon-verified" />
                </svg>
                <span>{{ $t('exchange.kyc') }}</span>
              </span>
              <!-- <span class="assets">~$ -</span> -->
            </div>
            <div class="merchant-left-footer col">
              <span>
                {{
                  $t('mine.createdAt', {
                    date: formatTime(ad.user.createdAt * 1000),
                  })
                }}
              </span>
              <span>
                {{
                  $t('takeOrder.lastSeen', {
                    duration: lastSeen(ad.user.updatedAt * 1000),
                  })
                }}
              </span>
            </div>
          </div>
          <div class="merchant-col-right">
            <div class="merchant-right-header">
              <span class="strong num-font">1</span>
              <span class="unit">{{ ad.asset.symbol }}</span>
              <span class="unit">=</span>
              <span
                :class="['strong', 'num-font', getFontClass(String(ad.price))]"
              >
                {{ ad.price }}
              </span>
              <span class="unit">{{ ad.legalCurrency.symbol }}</span>
            </div>
            <div class="merchant-right-body col">
              <span class="row-align-center exchange-tag" v-if="ad.isCheck">
                <svg class="icon-medal"><use :xlink:href="exchangeTag" /></svg>
                <svg class="icon-question" @click="showOptionalModeDialog">
                  <use xlink:href="#icon-question" />
                </svg>
              </span>
              <span style="color:red !important;"
                v-html="
                  $t('takeOrder.priceInfo', {
                    name: getSideTrans(ad.type).user,
                  })
                "
              ></span>
              <span>{{ timeText }}</span>
              <span class="strong" v-if="ad.user.hasCertified">{{
                $t('takeOrder.limitedTimeActivity')
              }}</span>
              <div class="pay-type">
                <div
                  class="pay-type-item row-align-center"
                  v-for="payMethod in ad.payMethods"
                  :key="payMethod.name"
                >
                  <img :src="getPayIcon(payMethod.name)" alt="" class="icon" />
                  <span>{{ $t(`payments.${payMethod.name}`) }}</span>
                </div>
              </div>
            </div>
            <div class="merchant-right-footer col">
              <span class="strong">{{ ad.title }}</span>
              <span class="remarks">{{ ad.description }}</span>
              <div class="btn-group row-center">
                <md-button type="primary" plain inline @click="onFQAClick">
                  <div class="row-center">
                    <svg class="btn-icon">
                      <use xlink:href="#icon-question-plain" />
                    </svg>
                    <span>{{ $t('mine.faq') }}</span>
                  </div>
                </md-button>
                <md-button type="primary" plain inline @click="onShareClick">
                  <div class="row-center">
                    <svg class="btn-icon"><use xlink:href="#icon-share" /></svg>
                    <span>{{ $t('takeOrder.share') }}</span>
                  </div>
                </md-button>
                <md-button type="primary" plain inline @click="onContactClick" style="display:none;" >
                  <div class="row-center">
                    <svg class="btn-icon">
                      <use xlink:href="#icon-message" />
                    </svg>
                    <span>{{ $t('takeOrder.contact') }}</span>
                  </div>
                </md-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="input-panel">
        <div class="input-panel-header row-align-center">
          <div class="input-header-left strong">
            {{ $t('takeOrder.tradeLimit') }}
          </div>
          <div class="input-header-mid">
            <span class="num"> {{ +ad.minPrice }} </span> ~
            <span class="num"> {{ +ad.maxPrice }} </span>
            {{ ad.legalCurrency.symbol }}
          </div>
          <!-- <div class="input-header-right row-center" @click="onShareClick">
            <svg class="icon"><use xlink:href="#icon-share" /></svg>
            <span>{{ $t('takeOrder.share') }}</span>
          </div> -->
        </div>
        <div class="input-panel-body">
          <md-input-item
            :class="['input-item', cnyAmountErrMsg ? 'error' : '']"
            type="number"
            :title="ad.legalCurrency.symbol"
            v-model="cnyAmount"
            v-input-mode="'decimal'"
            @change="onCnyAmountChange"
          >
            <div class="err-msg" slot="right">
              <span>{{ cnyAmountErrMsg }}</span>
            </div>
          </md-input-item>
          <md-input-item
            :class="['input-item', totalSumErrMsg ? 'error' : '']"
            type="number"
            :title="ad.asset.symbol"
            v-model="totalSum"
            v-input-mode="'decimal'"
            @change="onTotalSum"
          >
            <div class="err-msg" slot="right">
              <span>{{ totalSumErrMsg }}</span>
            </div>
          </md-input-item>
        </div>
        <div
          class="info-balance"
          v-if="balance && ad.type == 'buy'"
          @click="onSellAllClicked"
        >
          {{ $t('takeOrder.balance') }}
          {{ balance.balance }} {{ ad.asset.symbol }}
          <span v-if="balancePrice">
            ≈ {{ balancePrice }} {{ ad.legalCurrency.symbol }}
          </span>
        </div>
        <div class="input-panel-footer">
          <md-button
            :type="ad.type == 'sell' ? 'primary' : 'warning'"
            :inactive="isSubmitDisabled"
            @click="onSubmitClickPre"
          >
            <span>{{ $t('takeOrder.takeOrder') }}</span>
          </md-button>
        </div>
      </div>
      <div class="tips">
        {{ $t('takeOrder.safetyInfo') }}
      </div>
    </div>
    <md-popup v-model="isPopupShow" preventScroll :mask-closable="false">
      <div class="popup-wrapper col-center">
        <img class="popup-header" src="@/images/share-help-btn.svg" />
        <div class="popup-body">{{ $t('takeOrder.shareMsg') }}</div>
        <div class="popup-footer">
          <md-button
            :type="ad.type == 'buy' ? 'warning' : 'primary'"
            @click="closePopup"
          >
            <span>{{ $t('common.known') }}</span>
          </md-button>
        </div>
      </div>
    </md-popup>

    <md-dialog
      :title="this.$t('common.lossWarnTitle')"
      :closable="false"
      v-model="lossDialog.open"
      :btns="lossDialog.btns"
    >
        <span style="font-weight:bold;color:red;">
        <p
        v-html="$t('common.warnText1')"
        >
        </p>
        </span> 
        <span style="color:red;">
        {{$t('common.warnText2')}}
        </span>
        {{$t('common.warnText3')}}
        {{$t('common.warnText4')}}
        {{$t('common.warnText42')}}
        {{$t('common.adjustFeeText')}}
        <span style="font-weight:bold;color:red;">
        {{$t('common.warnText5')}}
        </span>
        <p style="margin-top: 5px;"></p>
       <md-agree
      v-model="agreeConf.checked"
      :disabled="agreeConf.disabled"
      :size="agreeConf.size"
      icon-type="square"
      @change="onAgreeChange(agreeConf.checked, $event)"
    >
         {{$t('common.warnText7')}}
      <a style="text-decoration: none;" href="javascript:void(0)" @click="showAgreement()" >《{{ $t('global.login.agreementName') }}》</a>
    </md-agree>
   
    </md-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import TheNavBar from '@/components/the-nav-bar';
import { InputItem, Button, Toast, Dialog, Popup, Agree } from 'mand-mobile';
import getDetail from '@/api/get-ad-detail';
import takeOrder from '@/api/post-take-order.js';
import toFixed from '@/utils/to-fixed.js';
import getPayIcon from '@/utils/get-payment-icon.js';
import isSupported from '@/utils/is-app-support.js';
import { mapState } from 'vuex';
import moment from 'moment';
import { Base64 } from 'js-base64';

export default {
  components: {
    'the-nav-bar': TheNavBar,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Agree.name]: Agree,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  filters: {
    formatRate(num) {
      num = (num * 100).toFixed(2);
      return `${+num}%`;
    },
  },
  data() {
    return {
      cnyAmount: '',
      cnyAmountErrMsg: '',
      totalSum: '',
      totalSumErrMsg: '',
      isSubmitting: false,
      paymentIcon: null,
      pollKey: null,
      agreeConf: {
        checked: false,
        name: 'agreeRisk',
        size: 'md',
        disabled: false,
        introduction: '风险须知同意',
      },
      lossDialog: {
        open: false,
        btns: [
          {
            text: this.$t('common.cancel'),
          },
          {
            text: this.$t('common.confirm'),
            warning: true,
            handler: this.onLossConfirm,
          },
        ],
      },
      ad: {
        id: '-',
        type: 'sell',
        title: '-',
        price: '',
        description: '-',
        minPrice: '',
        maxPrice: '',
        isCurr: 0,
        isCheck: false,
        asset: { name: '-', symbol: '-', iconUrl: null },
        legalCurrency: { name: '-', symbol: '-', precision: 0 },
        location: { name: null },
        payMethod: { name: 'default' },
        payMethods: [
          {
            name: 'default',
          },
        ],
        user: {
          id: '',
          nickname: '',
          avatarUrl: null,
          createdAt: 0,
          updatedAt: 0,
          multisigOrderCount: '-',
          hasVerified: false,
          hasCertified: false,
          hasVideo: false,
          rateRank: 0,
          orderSuccessRank: 0,
        },
        zone: '-',
        ontimeStart: '-',
        ontimeEnd: '-',
      },
      defaultAvatarUrl:
        '/storage/images/tigalocal.png',
      isPopupShow: false,
      inputRaceLock: {
        price: false,
        sum: false,
      },
    };
  },
  computed: {
    ...mapState({
      env: state => state.env,
      isLogin: state => state.isLogin,
      userInfo: state => state.userInfo,
      navLangMain: state => state.navLangMain,
      navLang: state => state.navLang,
      userAssets: state => state.userAssets,
    }),
    exchangeTag() {
      return `#icon-medal-${this.navLangMain}`;
    },
    balance() {
      if (
        this.ad &&
        this.ad.asset &&
        this.ad.asset.id &&
        this.userAssets.length
      ) {
        return (
          this.userAssets.find(asset => asset.assetId === this.ad.asset.id) ||
          null
        );
      }
      return null;
    },
    balancePrice() {
      if (this.balance && this.ad.price) {
        return toFixed(
          this.balance.balance * this.ad.price,
          this.ad.legalCurrency.precision,
        );
      }
      return null;
    },
    isSubmitDisabled() {
      return !!(
        this.cnyAmountErrMsg ||
        this.totalSumErrMsg ||
        !this.cnyAmount ||
        !this.totalSum ||
        this.isSubmitting ||
        this.userInfo.id === this.ad.user.id
      );
    },
    title() {
      const name = this.$t(`payments.${this.ad.payMethod.name}`);
      if (this.ad.type === 'sell') {
        return this.ad.payMethods.length > 1
          ? this.$t('takeOrder.titleMultiSell')
          : this.$t('takeOrder.titleSell', { name });
      }
      return this.ad.payMethods.length > 1
        ? this.$t('takeOrder.titleMultiBuy')
        : this.$t('takeOrder.titleBuy', { name });
    },
    timeText() {
      const { zone, ontimeStart, ontimeEnd } = this.ad;
      if (isNaN(zone) || isNaN(ontimeStart) || isNaN(ontimeEnd)) {
        return '';
      }
      return `(GMT${
        zone >= 0 ? `+${zone}` : zone
      }:00 ${ontimeStart}:00-${ontimeEnd}:00)`;
    },
  },
  mounted() {
    Toast.loading(this.$t('common.loading'));
    if (!this.id) {
      Toast.hide();
      this.$router.push('/');
      return;
    }
    if (this.$route.query.code) {
      const code = this.$route.query.code;
      this.$router.replace({
        path: this.$route.path,
        query: {
          id: this.id,
        },
      });
      if (!this.userInfo.hasTraded && !this.userInfo.inviter) {
        this.$router.push({
          path: '/mine/inviteCode',
          query: {
            code: code,
          },
        });
      }
    }
    this.loadData()
      .then(() => {
        if (!this.ad.isCurr) {
          clearInterval(this.pollKey);
        }
        this.$store
          .dispatch('updateUserAsset', this.ad.asset.id)
          .catch(() => {});
        Toast.hide();
        document.title =
          this.ad.type === 'buy'
            ? this.$t('takeOrder.sellTo', {
              name: this.ad.user.nickname,
              coin: this.ad.asset.symbol,
            })
            : this.$t('takeOrder.buyFrom', {
              name: this.ad.user.nickname,
              coin: this.ad.asset.symbol,
            });
      })
      .catch(err => {
        Toast.failed(`${this.$t('error.occur')}${err.message}`);
      });
    this.pollKey = setInterval(() => {
      this.loadData().catch(() => {});
    }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.pollKey);
    document.title = 'TIGA';
  },
  methods: {
    getSideTrans(side, inverse = false) {
      if (inverse) {
        side = side === 'buy' ? 'sell' : 'buy';
      }

      return side === 'buy'
        ? {
          side: this.$t('common.sell'),
          user: this.$t('common.buyer'),
        }
        : {
          side: this.$t('common.buy'),
          user: this.$t('common.seller'),
        };
    },
    onCnyAmountChange() {
      if (this.inputRaceLock.price) return;
      this.$nextTick(() => {
        this.triggerLock('sum');
        let value = this.fixDecimal(
          this.cnyAmount,
          this.ad.legalCurrency.precision,
        );
        if (this.ad.price) {
          this.totalSum = toFixed(value / this.ad.price, 8);
          if (value > +this.ad.maxPrice || value < +this.ad.minPrice) {
            this.cnyAmountErrMsg = this.$t('takeOrder.priceNotInRange');
          } else {
            this.cnyAmountErrMsg = '';
          }
        }
        this.cnyAmount = value;
      });
    },
    onTotalSum() {
      if (this.inputRaceLock.sum) return;
      this.$nextTick(() => {
        this.triggerLock('price');
        let output = this.fixDecimal(this.totalSum, 8);
        if (this.ad.price) {
          let value = toFixed(
            output * this.ad.price,
            this.ad.legalCurrency.precision,
          );
          if (value > +this.ad.maxPrice || value < +this.ad.minPrice) {
            this.cnyAmountErrMsg = this.$t('takeOrder.priceNotInRange', {
              name: this.getSideTrans(this.ad.type).user,
            });
          } else {
            this.cnyAmountErrMsg = '';
          }
          this.cnyAmount = value;
        }
        this.totalSum = output;
      });
    },
    fixDecimal(num, precision) {
      let numStr = num.toString();
      if (isNaN(numStr)) {
        return numStr;
      }
      while (
        numStr[0] === '0' &&
        numStr[1] &&
        numStr[1] !== '.' &&
        numStr[1] !== 'e'
      ) {
        numStr = numStr.substr(1);
      }
      let numArr = numStr.split('.');
      if (numArr[1] !== undefined && numArr[1].length > precision) {
        numArr[1] = numArr[1].substring(0, precision);
        if (numArr[1]) {
          return numArr.join('.');
        } else {
          return numArr[0];
        }
      } else {
        return numStr;
      }
    },
    triggerLock(input) {
      this.inputRaceLock[input] = true;
      setTimeout(() => {
        this.inputRaceLock[input] = false;
      }, 100);
    },
    onAgreeChange(checked) { //下单前同意风险及用户条例
      this.agreeConf.checked = checked;
    },
    onLossConfirm() { //弹窗确认按钮
      if(this.agreeConf.checked == true){
        this.lossDialog.open = false;
        this.onSubmitClick();
      }
    },
    onSubmitClickPre() {
      //添加主网资产受损弹窗
      const _lossAssets = ['BTC','BOX','USDT(ERC20)','ETH'];
      var a = _lossAssets.includes(this.ad.asset.symbol);
      if(a){
        Dialog.confirm({
          title: this.$t('common.takeOrderAssetWarnTitle'),
          content: this.$t('common.takeOrderAssetWarnText'),
          confirmText: this.$t('common.confirm'),
          cancelText: this.$t('common.cancel'),
          onConfirm: () => {
            this.lossDialog.open = true;
            return;
          },
          onCancel: ()=> {
            return;
          },
        });
      }else{
        this.lossDialog.open = true;
        return; 
      }
  
    },
    onSubmitClick() {
      if (
        process.NODE_ENV === 'production' &&
        ((this.env.isInIos && !isSupported(this.env.appVersion, '0.19.0')) ||
          (this.env.isInAndroid && !isSupported(this.env.appVersion, '0.18.0')))
      ) {
        return Dialog.alert({
          icon: 'warn',
          title: this.$t('takeOrder.noSupported'),
          confirmText: this.$t('common.confirm'),
        });
      }
      let promise = Promise.resolve();
      let isDialogShown = window.localStorage.getItem('exchange_dialog');
      if (this.ad.type === 'sell' && !isDialogShown) {
        promise = new Promise((resolve, reject) => {
          const that = this;
          const DialogConstructor = Vue.extend({
            props: {
              value: {
                type: Boolean,
                default: false,
              },
            },
            data: function () {
              return {
                isChecked: false,
                count: 5,
                timeout: null,
              };
            },
            computed: {
              btns() {
                return [
                  {
                    text: that.$t('common.cancel'),
                    handler: this.onCancelBtnClicked,
                  },
                  {
                    text:
                      this.count >= 0
                        ? `${this.count}s`
                        : that.$t('common.confirm'),
                    handler: this.onBtnClicked,
                  },
                ];
              },
            },
            mounted() {
              this.countdown();
            },
            methods: {
              onInput(val) {
                this.$emit('input', val);
                this.isChecked = false;
              },
              onBtnClicked() {
                if (this.count < 0) {
                  if (this.isChecked) {
                    window.localStorage.setItem('exchange_dialog', 1);
                  }
                  this.onInput(false);
                  resolve();
                }
              },
              onCancelBtnClicked() {
                clearTimeout(this.timeout);
                this.onInput(false);
                reject();
              },
              onCheckChange() {
                this.isChecked = !this.isChecked;
              },
              countdown() {
                if (this.count >= 0) {
                  this.count--;
                  this.timeout = setTimeout(this.countdown, 1000);
                }
              },
            },
            render: function () {
              return (
                <md-dialog
                  vModel={this.value}
                  title={that.$t('common.notice')}
                  btns={this.btns}
                  closable={false}
                  onInput={this.onInput}
                >
                  <p
                    class="dialog-text"
                    domPropsInnerHTML={that.$t('takeOrder.forbiddenRemark')}
                  ></p>
                  <br />
                  <md-agree
                    class="dialog-agree"
                    vModel={this.isChecked}
                    nativeOnClick={this.onCheckChange}
                  >
                    {that.$t('common.stopRemind')}
                  </md-agree>
                </md-dialog>
              );
            },
          });
          const vm = new DialogConstructor().$mount();
          vm.$once('input', val => {
            if (!val) {
              vm.$destroy();
            }
            vm.value = val;
          });
          vm.value = true;
        });
      }
      promise
        .then(() => {
          this.isSubmitting = true;
          takeOrder(
            this.ad.price,
            this.totalSum,
            this.cnyAmount,
            this.ad.id,
            this.navLang,
          )
            .then(data => {
              this.isSubmitting = false;
              Dialog.alert({
                icon: 'success-color',
                title: this.$t('takeOrder.successMsg'),
                confirmText: this.$t('common.confirm'),
                onConfirm: () => {
                  window.open(data.data.conversation_url, '_blank', 'noopener');
                  this.$nextTick(() => {
                    this.$router.back();
                  });
                },
              });
            })
            .catch(err => {
              this.isSubmitting = false;
              if (err.code == '1030' || err.code == '1044') {
                return Dialog.failed({
                  title: err.message,
                  cancelText: this.$t('common.cancel'),
                  confirmText: this.$t('exchange.goKyc'),
                  onConfirm: () => {
                    this.$router.push('/mine/payInfo');
                  },
                });
              }
              if (err.code == '1045') {
                return Dialog.failed({
                  title: err.message,
                  cancelText: this.$t('common.cancel'),
                  confirmText: this.$t('common.follow'),
                  onConfirm: () => {
                    window.location.href =
                      'mixin://users/1906a44a-d9eb-4d22-b4c7-b46a85969d5c';
                  },
                });
              }
              if (err.code == '1056') {
                return Dialog.failed({
                  title: err.message,
                  cancelText: this.$t('common.cancel'),
                  confirmText: this.$t('takeOrder.contact'),
                  onConfirm: this.onContactClick,
                });
              }
              Dialog.failed({
                title: err.message,
                confirmText: this.$t('common.confirm'),
                cancelText: this.$t('common.cancel'),
              });
            });
        })
        .catch(() => {});
    },
    formatTime(unix) {
      return moment(unix).format('YYYY/MM/DD');
    },
    lastSeen(unix) {
      let diff = moment(unix).diff(moment());
      let duration = moment.duration(diff);
      return duration.locale(this.navLang).humanize(true);
    },
    getFontClass(str) {
      if (str.length > 8) {
        return 'small';
      }
      return '';
    },
    loadData() {
      return getDetail(this.id)
        .then(data => {
          Object.assign(this.ad, data.data);
          this.ad.legalCurrency.precision = this.ad.legalCurrency.decimal_digit;
          this.ad.user.hasVerified = !!this.ad.user.trueName;
          this.ad.user.hasCertified = this.ad.user.isLandun;
          this.ad.user.hasVideo = this.ad.user.hasVideo;
          this.paymentIcon = getPayIcon(this.ad.payMethod.name);
          return Promise.resolve();
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    onFQAClick() {
      this.$router.push('/faq');
    },
    onShareClick() {
      if (
        this.env.isInMixin &&
        ((this.env.isInIos && !isSupported(this.env.appVersion, '0.27.1')) ||
          (this.env.isInAndroid && !isSupported(this.env.appVersion, '0.27.2')))
      ) {
        let data = Base64.encode(
          JSON.stringify({
            app_id: '1906a44a-d9eb-4d22-b4c7-b46a85969d5c',
            icon_url: this.ad.asset.iconUrl,
            action: window.location.href,
            title:
              this.ad.type === 'buy'
                ? this.$t('takeOrder.sellTo', {
                  name: this.ad.user.nickname,
                  coin: this.ad.asset.symbol,
                })
                : this.$t('takeOrder.buyFrom', {
                  name: this.ad.user.nickname,
                  coin: this.ad.asset.symbol,
                }),
            description: 'TIGA',
          }),
        );
        window.location.href = `mixin://send?category=app_card&data=${encodeURIComponent(
          data,
        )}`;
      } else {
        this.isPopupShow = true;
      }
    },
    onContactClick() {
      window.open(`mixin://users/${this.ad.user.mixinUuid}`);
    },
    closePopup() {
      this.isPopupShow = false;
    },
    getPayIcon(name) {
      return getPayIcon.call(null, name);
    },
    onSellAllClicked() {
      if (this.balance && !isNaN(this.balance.balance)) {
        this.totalSum = this.balance.balance;
        this.onTotalSum();
      }
    },
    fix(num) {
      if (num >= 10) {
        return num;
      }
      return '0' + num;
    },
    showOptionalModeDialog() {
      Dialog.alert({
        icon: 'icon-smile',
        iconSvg: true,
        content: this.$t('takeOrder.optionalModeDetail'),
        confirmText: this.$t('common.known'),
      });
    },
    showAgreement() {
      var hrefObj = { 
        'zh-cn': 'https://help.tigaex.com/en/service-terms.html',
        en: 'https://help.tigaex.com/en/service-terms.html',
      };
      window.open(
        hrefObj[this.navLang],
        '_blank',
        'noopeener',
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.nav-header {
  .nav-title {
    font-size: 3.47vw;
  }

  .nav-title-icon {
    margin-right: 2.13vw;
    icon-size(6.4vw);
  }

  .nav-right {
    min-width: 15vw;
    font-size: 2.67vw;
    color: #84969c;
    white-space: nowrap;

    .nav-right-icon {
      margin-left: 1.07vw;
      icon-size(3.73vw);
    }
  }
}

.strong {
  font-weight: bold;
  color: color-text-base;
}

.body-wrapper {
  padding: 0 4.8vw 30vw;
  background: inherit;
}

.merchant-panel {
  .merchant-header {
    padding: 6.4vw 0 9.6vw;
    font-size: 3.73vw;
    font-weight: bold;
    color: color-text-base;

    .icon {
      margin-right: 4.8vw;
      icon-size(10.67vw);
    }
  }

  .merchant-col-left {
    flex: 0 0 26.4vw;
    font-size: 2.13vw;
    line-height: 3.2vw;
    color: #84969c;

    .merchant-left-header {
      margin-bottom: 2.13vw;
      display: flex;
      flex-direction: column;

      .avatar {
        margin-bottom: 2.13vw;
        box-sizing: border-box;
        width: 14.93vw;
        height: 14.93vw;
        border-radius: 2.67vw;
        border: 0.27vw solid #eaf1f3;
      }

      .name {
        font-size: 3.2vw;
      }
    }

    .merchant-left-body {
      margin-bottom: 2.13vw;

      .tag {
        margin-top: 1.07vw;
        font-size: 2.13vw;
        color: #0082FC;

        .icon {
          margin-right: 1.07vw;
          width: 2.67vw;
          height: 2.67vw;
        }
      }
    }
  }

  .merchant-col-right {
    flex-grow: 1;

    .merchant-right-header {
      margin-bottom: 2.13vw;
      font-size: 4.27vw;
      display: block;
      align-items: baseline;

      .strong {
        font-size: 8vw;
      }

      .small {
        font-size: 6.4vw;
      }

      .unit {
        margin: 0 1.07vw;
      }
    }

    .merchant-right-body {
      margin-bottom: 4.8vw;
      font-size: 2.67vw;
      line-height: 1.6;
      color: #84969c;

      .exchange-tag {
        margin: 2.13vw 0;
      }

      .icon-medal {
        width: 16vw;
        height: 3.73vw;
      }

      .icon-question {
        margin-left: 1.07vw;
        width: 3.73vw;
        height: 3.73vw;
        color: color-text-base;
      }

      .strong {
        font-weight: normal;
        color: #0082fc;
      }

      .pay-type {
        margin-top: 2.13vw;
        color: color-text-base;
        display: flex;
        flex-wrap: wrap;

        .pay-type-item {
          margin-top: 1.07vw;

          & + .pay-type-item {
            margin-left: 4.8vw;
          }
        }

        .icon {
          margin-right: 1.07vw;
          height: 4.27vw;
        }
      }
    }

    .merchant-right-footer {
      .remarks {
        margin-top: 1.07vw;
        font-size: 2.67vw;
      }

      .btn-group {
        margin-top: 7.73vw;
        justify-content: flex-end;

        .md-button {
          padding: 0;
          width: 19.73vw;
          height: 5.87vw;
          font-size: 2.67vw;

          & + .md-button {
            margin-left: 2.4vw;
          }
        }

        .btn-icon {
          margin-right: 1.07vw;
          width: 4.8vw;
          height: 4.8vw;
        }
      }
    }
  }
}

.input-panel {
  margin: 4.8vw 0;

  .input-panel-header {
    margin-bottom: 2.13vw;
    height: 11.73vw;

    .input-header-mid {
      flex: 1 0 0%;
      margin: 0 4.27vw;
      font-size: 2.13vw;
      color: #dc521b;

      .num {
        font-size: 3.2vw;
      }
    }

    .input-header-right {
      color: color-primary;

      .icon {
        margin-right: 1.07vw;
        width: 5.33vw;
        height: 5.33vw;
      }
    }
  }

  .input-item {
    margin-bottom: 4.8vw;
    border: 0.27vw solid #eaf1f3;
    border-radius: 2.67vw;
    background: #f8fbfc;

    &.error >>> .md-input-item-input {
      color: field-item-addon-color;
    }

    & >>> .md-input-item-input {
      font-weight: normal;
    }

    & >>> .md-field-item-content:before {
      content: none !important;
    }

    & >>> .md-field-item-title {
      margin-left: 2.13vw;
      width: auto;
    }

    .err-msg {
      padding-right: 4.8vw;
    }
  }

  .info-balance {
    color: #84969C;
    margin: 2.13vw 0 4.8vw;
    font-size: 2.67vw;
  }
}

.tips {
  margin-top: 4.8vw;
  font-size: 2.67vw;
}

.flag-icon {
  margin-left: 1.33vw;
  margin-right: 4.7vw;
  width: 3.73vw;
  height: 3.73vw;
  border-radius: 50%;
}

.popup-wrapper {
  box-sizing: border-box;
  border-radius: 4.27vw;
  width: 80vw;
  padding: 5.33vw 4.27vw;
  background: #fff;

  .popup-header {
    width: 20vw;
  }

  .popup-body {
    margin-top: 4.27vw;
    font-size: 3.73vw;
  }

  .popup-footer {
    margin: 5.33vw auto 0;
    width: 53.33vw;
  }
}

.dialog-text {
  >>> .important {
    font-size: 4.8vw;
    font-weight: bold;
    color: #ff2d55;
  }
}

.dialog-agree {
  >>> .md-agree-icon {
    pointer-events: none;
  }
}


</style>
